module.exports = "/_next/static/images/37f39e2e6ddf365171791a934d648a1d-man-looking-up-smiling-lg@3x.jpg";